import { handleResponse, handleError, headerset } from "../apiUtils";

import { VariazioneDisponibilita } from "../../components/main/schedulazione/variazioniDisponibilitaSlice";

// ============================================
// BASE URL
// ============================================

const baseUrl = () => {
    return process.env.API_URL + "/api/personale/variazioni-disponibilita/";
};

// ============================================
// QUERY STRING HELPER
// ============================================

export interface VariazioniFetchParams {
    dataDa: string;                          // YYYY-MM-DD inizio finestra
    dataA: string;                           // YYYY-MM-DD fine finestra
    repartiIds?: number[];
    operatoriIds?: number[];
    operatoreIsnull?: boolean;
    includeOperatoriDiReparto?: boolean;
}

function buildQuery(params: VariazioniFetchParams): string {
    const search = new URLSearchParams();
    search.append("data_da", params.dataDa);
    search.append("data_a", params.dataA);
    if (params.repartiIds && params.repartiIds.length > 0) {
        search.append("reparti_ids", params.repartiIds.join(","));
    }
    if (params.operatoriIds && params.operatoriIds.length > 0) {
        search.append("operatori_ids", params.operatoriIds.join(","));
    }
    if (params.operatoreIsnull) {
        search.append("operatore_isnull", "true");
    }
    if (params.includeOperatoriDiReparto) {
        search.append("include_operatori_di_reparto", "true");
    }
    search.append("numero_record", "500");
    return search.toString();
}

// ============================================
// API FUNCTIONS
// ============================================

export function fetchVariazioni(params: VariazioniFetchParams) {
    const url = `${baseUrl()}?${buildQuery(params)}`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function createVariazione(variazione: VariazioneDisponibilita) {
    return fetch(baseUrl(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
        body: JSON.stringify(variazione),
    })
        .then(handleResponse)
        .catch(handleError);
}

export function updateVariazione(variazione: VariazioneDisponibilita) {
    if (!variazione.id) {
        return Promise.reject(new Error("updateVariazione richiede un id"));
    }
    return updateVariazionePartial(variazione.id, variazione);
}

/**
 * PUT partial: invia solo i campi presenti nel patch (es. {data_da, data_a} per drag/resize).
 * Il backend accetta partial via `partial=True` nel serializer.
 */
export function updateVariazionePartial(id: number, patch: Partial<VariazioneDisponibilita>) {
    const url = `${baseUrl()}${id}/`;
    return fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
        body: JSON.stringify(patch),
    })
        .then(handleResponse)
        .catch(handleError);
}

export function deleteVariazione(id: number) {
    const url = `${baseUrl()}${id}/`;
    return fetch(url, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}
